import { api } from '@cloudsuite/theme_library/scripts/helper';

const config = {
    showLoggedOutNotification: true,
    showLoggedInNoglobaltification: true,
    customerUsesMultipleLanguages: true,
    language: $('#enterpriseDomain').val().split('_')[0]
};

// LOGGED IN
function checkIfProductInWishList(response, product_id) {
    const wishlist = response.state;
    if (!wishlist) {
        return false
    }

    for (let i = 0; i < wishlist.length; i++) {
        let item = wishlist[i];
        if (parseInt(product_id) === item['product_id']) {
            return item['is_enabled']
        }
    }
    return false
}

$(document).on('click', '.js-favorite', async function (event) {
    event.preventDefault();

    let $this = $(this);
    const url = $this.attr('data-url');
    const product_id = $this.attr('data-id');
    const is_enabled = $this.children('i').hasClass('far');
    const wishlistbadge = $('.js-wishlist-link');
    const currentcount = parseInt($(wishlistbadge).find('.badge').data('count') || 0);
    const extraUrl = $(this).attr('data-remove-url');
    const message = $(this).data('msg');
    const product_attributes = $this.data('ega');
    let product = $this.attr('data-product');
    const productData = JSON.parse(product);

    const button = event.target.offsetParent

    button.disabled = true

    const categories =  await api.get($this.data("tree-parents-url").replace('999999', productData.tree))
    .then((trees) => {
        return trees.map(tree => tree.name).join('/');
    });

    $.ajax({
        url: url,
        data: JSON.stringify({ 'state': [{ 'product_id': product_id, 'is_enabled': is_enabled }] }),
        contentType: "application/json",
        method: 'POST',
        success: function (response) {
            button.disabled = false

            let isProductInWishList = checkIfProductInWishList(response, product_id);
            let faClassWishList = isProductInWishList ? 'fas fa-heart' : 'far fa-heart';
            let removeClassWishList = isProductInWishList ? 'far fa-heart' : 'fas fa-heart';
            let changeTitle = isProductInWishList ? $this.attr('data-inWishlistTitle') : $this.attr('data-outWishlistTitle');

            $this.children('i').attr('title', changeTitle);
            $this.find('small').text(changeTitle);
            $this.children('i').attr('data-original-title', changeTitle);
            $this.children('i').removeClass(removeClassWishList);
            $this.children('i').addClass(faClassWishList);

            $.notifyClose();
            $.get(url, function () {
                $.notify({
                    message: message
                }, {
                    type: 'info',
                    z_index: 99999999,
                    delay: 1000
                });
            });

            if(!$(wishlistbadge).find('.badge').length > 0) {
                $(wishlistbadge).append(`<div class="badge"><span></span></div>`);
            }

            if (isProductInWishList) {
                if (currentcount > 99) {
                    $(wishlistbadge).find('.badge').html(`<span>99+</span>`);
                    $(wishlistbadge).find('.badge').attr('data-count', '99');
                } else {
                    $(wishlistbadge).find('.badge').html(`<span>${currentcount + 1}</span>`);
                    $(wishlistbadge).find('.badge').data('count', currentcount + 1);
                }
                
                const dataDelivery = () => {
                    if ($('[data-js-ga-delivery-days]')) {
                        return {
                        'delivery_text': $this.closest('.data-js-product').find("[data-js-ga-delivery-days] p").text(),
                        'delivery_days': $this.closest('.data-js-product').find("[data-js-ga-delivery-days]").attr('data-js-ga-dd'),
                        'stock_text': $this.closest('.data-js-product').find("[data-js-ga-delivery-days] [data-js-ga-stock-msg]").attr('data-js-ga-stock-msg'),
                        'stock_quantity': $this.closest('.data-js-product').find("[data-js-ga-delivery-days] [data-js-ga-stock-msg]").attr('data-js-ga-stock'),
                        }
                    }
                }

                const clickTrigger = () => {
                    const triggerEvent = $this.attr('data-js-ga-trigger');
                    let triggerValue;
                    if (window.innerWidth < 768) {
                      triggerValue = `${triggerEvent}_mobile`;
                    } else {
                      triggerValue = `${triggerEvent}_desktop`;
                    }
              
                    return triggerValue;
                }

                if (is_enabled && !$this[0].hasAttribute('data-js-hotspot-wishlist')) {
                    dataLayer.push({
                        'event': 'addToWishlist',
                        'location': window.location.href,
                        ...$this.attr('data-js-ga-trigger') ? {details: clickTrigger()} : [],
                        'ecommerce': {
                            'currencyCode': 'EUR',
                            'add': { // 'add' actionFieldObject measures.
                                'actionField': undefined,
                                'products': [
                                    {
                                        "name": productData.name,
                                        "id": productData.code,
                                        "price": `${productData.sale_price_no_format.toFixed(2)}`,
                                        "brand": productData.brand,
                                        ...(categories && {"category": `${categories}/${productData.tree_name}`}),
                                        ...(product_attributes && product_attributes.kleur ? {"kleur": product_attributes.kleur} : []),
                                        ...(product_attributes && product_attributes.kleurstaal ? {"kleurstaal": product_attributes.kleurstaal} : []),
                                        ...(product_attributes && product_attributes.material ? {"material": product_attributes.material} : []),
                                        ...(product_attributes && product_attributes.stijl ? {"stijl": product_attributes.stijl} : []),
                                        "variant": productData.name_with_attributes
                                    }
                                ]
                            }
                        },
                        ...dataDelivery()
                    });
                }

            } 
            else {
                if(currentcount - 1 > 0) {
                    $(wishlistbadge).find('.badge').html(`<span>${currentcount - 1}</span>`);
                    $(wishlistbadge).find('.badge').data('count', currentcount - 1);
                } else {
                    $(wishlistbadge).find('.badge').remove();
                }
            }
            if (config.showLoggedInNotification) {
                $.notify({
                    message: isProductInWishList ? js_translations.wishlistproductadded : js_translations.wishlistproductremoved
                }, {
                    z_index: 99999999,
                    type: 'info',
                    delay: 1000
                });
            }

            if (extraUrl) {
                window.location.href = extraUrl;
            }
            else if ($this.hasClass('js-reload')) {
                window.location.reload();
            }
        }
    })
});
